import { render, staticRenderFns } from "./AdminUpdateItem.vue?vue&type=template&id=79172464&scoped=true&"
import script from "./AdminUpdateItem.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateItem.vue?vue&type=style&index=0&id=79172464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79172464",
  null
  
)

export default component.exports